/*
All material copyright ESRI, All Rights Reserved, unless otherwise specified.
See https://js.arcgis.com/4.28/esri/copyright.txt for details.
*/
import{c as n}from"../../chunks/vec3f64.js";import{projectBuffer as r}from"./projectBuffer.js";function t(n,t,e,c){return!(null==t||null==c||n.length<2)&&(2===n.length&&(o[0]=n[0],o[1]=n[1],o[2]=0,n=o),r(n,t,0,e,c,0,1))}const o=n();export{t as projectVectorToVector};
